
import { api } from "../api";

/**
 * customerfindAllCrudResponse - Function that finds on database all customers by status as crud response data   
 * /customers/{managerId}/{status}  
 * method GET 
 * @async-function
 */
const customerfindAllCrudResponse = async (token: string, status: string, managerId: number, page: number, size: number) => {
    const response = await api.get(
        `/customers/${managerId}/${status}?page=${page}&size=${size}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default customerfindAllCrudResponse;